import {
  FEATURE_FLAG_KEYS,
  FEATURE_FLAG_LABELS,
  flagToApi,
  flagToUi,
  ProjectFeatureFlags,
} from 'shared/utils/feature-flags';

import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface Props {
  value: ProjectFeatureFlags;
  onChange: (next: ProjectFeatureFlags) => void;
  heading?: string;
}

export const DEFAULT_FEATURE_FLAGS: ProjectFeatureFlags = {
  skipFinancialDataValidationOnIncome: true,
  hasProperties: true,
  hasSaveEmployementDetailsFunctionality: false,
  includeSaveBuyerTypeFunction: false,
  enableRegistroCivilFeature: false,
  enableCamaraComercioFeature: false,
  documentAnalyzerEnabled: true,
};

const FeatureToggleGroup = ({ value, onChange, heading = 'Características' }: Props) => {
  const handleToggle = (key: keyof ProjectFeatureFlags) => (checked: boolean) => {
    onChange({ ...value, [key]: flagToApi(key, checked) });
  };

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold text-text-default">{heading}</h3>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {FEATURE_FLAG_KEYS.map((key) => {
          const meta = FEATURE_FLAG_LABELS[key];
          const fieldId = `feature-toggle-${key}`;
          return (
            <div key={key} className="flex items-start justify-between gap-3 rounded-md border border-border p-3">
              <div className="space-y-1 pr-2">
                <Label htmlFor={fieldId} className="text-sm font-medium">
                  {meta.title}
                </Label>
                <p className="text-xs text-text-muted">{meta.description}</p>
              </div>
              <Switch id={fieldId} checked={flagToUi(key, value[key])} onCheckedChange={handleToggle(key)} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FeatureToggleGroup;
